<template>
  <modal :show.sync="openDirectPayoutDetailsModal" >
    <b-row class="approval-direct-payout" style="min-width: 1200px;" v-if="current_comms_payout_summaries">
        <b-col cols="12">
            <h4 class="mb-3">Direct, Recruitment and Pool Payout Details</h4>
            <b-row>
              <b-col cols="12" md="6">
                <table class="table table-bordered">
                  <thead>
                      <tr>
                        <th class="bg-primary text-white py-2" width="150px">Comms Payout Summary ID</th>
                        <td class="py-2">#{{ current_comms_payout_summaries.comms_payout_summary_id }}</td>
                      </tr>
                      <template v-if="current_comms_payout_summaries.case">
                        <tr>
                          <th class="bg-primary text-white py-2">Case ID</th>
                          <td class="py-2">#{{ current_comms_payout_summaries.case.prod_id }}</td>
                        </tr>
                        <tr>
                          <th class="bg-primary text-white py-2">Customer Name</th>
                          <td class="py-2">
                            <router-link :to="'/customerProfileDetails/' + current_comms_payout_summaries.case.prod_customer_id + '?active=overview'" class="text-primary" target="_blank">
                              {{ current_comms_payout_summaries.case.prod_customer_name }}
                            </router-link>
                          </td>                        
                        </tr>
                        <tr>
                          <th class="bg-primary text-white py-2">Product Type</th>
                          <td class="py-2">{{ current_comms_payout_summaries.case.prod_type }}</td>
                        </tr>
                        <tr>
                          <th class="bg-primary text-white py-2">Product Details</th>
                          <template v-if="current_comms_payout_summaries.case.prod_type == 'property' || current_comms_payout_summaries.case.prod_type == 'mortgage'">
                            <div v-if="current_comms_payout_summaries.case.prod_details.property_mortgage">
                              <td class="py-2">
                                <div>{{ current_comms_payout_summaries.case.prod_details.property_mortgage.prod_pm_project_name }}</div>
                                <div>{{ current_comms_payout_summaries.case.prod_details.property_mortgage.prod_pm_lease_type }}</div>
                                <div>{{ current_comms_payout_summaries.case.prod_details.property_mortgage.prod_pm_unit_no }}</div>
                              </td>
                            </div>
                          </template>
                          <template v-else-if="current_comms_payout_summaries.case.prod_type == 'personal_loan' && current_comms_payout_summaries.case.prod_details.personal_loan">
                            <td class="py-2">{{ current_comms_payout_summaries.case.prod_details.personal_loan.prod_pl_loan_agreement_rate | moneyFormatter }}</td>
                          </template>
                          <template v-else-if="current_comms_payout_summaries.case.prod_type == 'insurance' && current_comms_payout_summaries.case.prod_details.insurance">
                            <td class="py-2">
                              <div>{{ current_comms_payout_summaries.case.prod_details.insurance.prod_ins_type }}</div>
                              <div>{{ current_comms_payout_summaries.case.prod_details.insurance.prod_ins_package }}</div>
                              <div>{{ current_comms_payout_summaries.case.prod_details.insurance.prod_ins_company }}</div>
                              <div>{{ current_comms_payout_summaries.case.prod_details.insurance.prod_ins_premium_pa | moneyFormatter }}</div>
                              <div>{{ current_comms_payout_summaries.case.prod_details.insurance.prod_ins_premium_pm | moneyFormatter }}</div>
                              <div>{{ current_comms_payout_summaries.case.prod_details.insurance.prod_ins_premium_cover | moneyFormatter }}</div>
                            </td>
                          </template>
                          <template v-else>
                            <td class="py-2">{{ current_comms_payout_summaries.case.prod_details }}</td>
                          </template>
                        </tr>
                      </template>
                      <tr>
                        <th class="bg-primary text-white py-2">Net Price</th>
                        <td class="py-2" v-if="!show_actual_revenue">
                          {{ current_comms_payout_summaries.cps_develop_nett_price | moneyFormatter }}
                          <el-button class="bg-success py-2 px-3 text-white" v-if="permission.approver && decide_mode" @click="toggleActualRevenueAmountModal">
                            Submit Actual Revenue
                          </el-button>
                        </td>
                        <td class="py-2" v-else>
                          {{ current_comms_payout_summaries.cps_actual_develop_nett_price | moneyFormatter }} <span><i class="fa fa-check-circle text-success"></i></span>
                        </td>
                      </tr>
                      <tr>
                        <th class="bg-primary text-white py-2">Hub</th>
                        <td class="py-2" v-if="current_comms_payout_summaries.hub">{{ current_comms_payout_summaries.hub.hub_name }} | {{ current_comms_payout_summaries.hub.hub_team.hub_team_name }} | {{ current_comms_payout_summaries.hub.hub_team.hub_team_leader.name }}</td>
                      </tr>
                      <template v-if="current_comms_payout_summaries.case_recognize">
                        <tr>
                          <th class="bg-primary text-white py-2">SE</th>
                          <td class="py-2" v-if="current_comms_payout_summaries.case_recognize.user">{{  current_comms_payout_summaries.case_recognize.user.name }}</td>
                        </tr>
                        <tr>
                          <th class="bg-primary text-white py-2">SSA</th>
                          <td class="py-2" v-if="current_comms_payout_summaries.case_recognize.use_user">{{  current_comms_payout_summaries.case_recognize.use_user.name }}</td>
                        </tr>
                        <tr>
                          <th class="bg-primary text-white py-2">SSE</th>
                          <td class="py-2" v-if="current_comms_payout_summaries.case_recognize.use_user2">{{  current_comms_payout_summaries.case_recognize.use_user2.name }}</td>
                        </tr>
                      </template>
                  </thead>
                </table>

                <base-button type="primary" v-if="!show_actual_revenue" @click="toggleShowActualRevenue">Show Actual Revenue</base-button>
                <base-button type="primary" v-else @click="toggleShowActualRevenue">Show Pre Revenue</base-button>
              </b-col>

              <modal :show.sync="openActualRevenueAmountModal">
                <b-form-group label="Actual Revenue Amount (RM)">
                  <CurrencyInput
                    v-model="actual_revenue_value"
                    :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                  />
                </b-form-group>
                <div class="d-flex justify-content-between">
                  <el-button class="bg-success py-2 px-3 text-white text-right" 
                    @click="submitActualRevenue"
                  >Submit
                  </el-button>
                </div>
              </modal>

              <b-col cols="12" md="6" v-if="comms_payout_summaries">
                <table class="table table-bordered" v-if="comms_payout_summaries[0]">
                  <thead v-if="!show_actual_revenue">
                      <tr>
                        <th class="bg-primary text-white py-2" width="150px">Service Type Percentage (%)</th>
                        <td class="py-2">{{ comms_payout_summaries[0].cps_service_type_percentage }} %</td>
                      </tr>
                      <tr>
                        <th class="bg-primary text-white py-2" width="150px">Total Revenue Point</th>
                        <td class="py-2">RM {{ comms_payout_summaries[0].cps_total_revenue_point | moneyFormatter }}</td>
                      </tr>
                      <tr>
                        <th class="bg-primary text-white py-2">Direct Payout ({{ comms_payout_summaries[0].cps_direct_payout_allocation_percentage }} %)</th>
                        <td class="py-2">RM {{ comms_payout_summaries[0].cps_balance_revenue_point | moneyFormatter }}</td>
                      </tr>
                      <tr>
                        <th class="bg-primary text-white py-2">Pool Payout ({{ comms_payout_summaries[0].cps_pool_allocation_percentage }} %)</th>
                        <td class="py-2">RM {{ comms_payout_summaries[0].cps_pool_revenue_point | moneyFormatter }}</td>
                      </tr>
                  </thead>
                  <thead v-else>
                      <tr>
                        <th class="bg-primary text-white py-2" width="150px">Service Type Percentage (%)</th>
                        <td class="py-2">{{ comms_payout_summaries[0].cps_service_type_percentage }} %</td>
                      </tr>
                      <tr>
                        <th class="bg-primary text-white py-2" width="150px">Total Revenue Point</th>
                        <td class="py-2">RM {{ comms_payout_summaries[0].cps_actual_total_revenue_point | moneyFormatter }}</td>
                      </tr>
                      <tr>
                        <th class="bg-primary text-white py-2">Direct Payout ({{ comms_payout_summaries[0].cps_direct_payout_allocation_percentage }} %)</th>
                        <td class="py-2">RM {{ comms_payout_summaries[0].cps_actual_balance_revenue_point | moneyFormatter }}</td>
                      </tr>
                      <tr>
                        <th class="bg-primary text-white py-2">Pool Payout ({{ comms_payout_summaries[0].cps_pool_allocation_percentage }} %)</th>
                        <td class="py-2">RM {{ comms_payout_summaries[0].cps_actual_pool_revenue_point | moneyFormatter }}</td>
                      </tr>
                  </thead>
                </table>
                <template v-if="comms_payout_summaries[1]">
                  <h4>Advisory</h4>
                  <table class="table table-bordered" v-if="!show_actual_revenue">
                    <thead>
                        <tr>
                          <th class="bg-primary text-white py-2" width="150px">Service Type Percentage (%)</th>
                          <td class="py-2">{{ comms_payout_summaries[1].cps_service_type_percentage }} %</td>
                        </tr>
                        <tr>
                          <th class="bg-primary text-white py-2" width="150px">Total Revenue Point</th>
                          <td class="py-2">RM {{ comms_payout_summaries[1].cps_total_revenue_point | moneyFormatter }}</td>
                        </tr>
                        <tr>
                          <th class="bg-primary text-white py-2">Direct Payout ({{ comms_payout_summaries[1].cps_direct_payout_allocation_percentage }} %)</th>
                          <td class="py-2">RM {{ comms_payout_summaries[1].cps_balance_revenue_point | moneyFormatter }}</td>
                        </tr>
                        <tr>
                          <th class="bg-primary text-white py-2">Pool Payout ({{ comms_payout_summaries[1].cps_pool_allocation_percentage }} %)</th>
                          <td class="py-2">RM {{ comms_payout_summaries[1].cps_pool_revenue_point | moneyFormatter }}</td>
                        </tr>
                    </thead>
                  </table>
                  <table class="table table-bordered" v-else>
                    <thead>
                        <tr>
                          <th class="bg-primary text-white py-2" width="150px">Service Type Percentage (%)</th>
                          <td class="py-2">{{ comms_payout_summaries[1].cps_service_type_percentage }} %</td>
                        </tr>
                        <tr>
                          <th class="bg-primary text-white py-2" width="150px">Total Revenue Point</th>
                          <td class="py-2">RM {{ comms_payout_summaries[1].cps_actual_total_revenue_point | moneyFormatter }}</td>
                        </tr>
                        <tr>
                          <th class="bg-primary text-white py-2">Direct Payout ({{ comms_payout_summaries[1].cps_direct_payout_allocation_percentage }} %)</th>
                          <td class="py-2">RM {{ comms_payout_summaries[1].cps_actual_balance_revenue_point | moneyFormatter }}</td>
                        </tr>
                        <tr>
                          <th class="bg-primary text-white py-2">Pool Payout ({{ comms_payout_summaries[1].cps_pool_allocation_percentage }} %)</th>
                          <td class="py-2">RM {{ comms_payout_summaries[1].cps_actual_pool_revenue_point | moneyFormatter }}</td>
                        </tr>
                    </thead>
                  </table>
                </template>
              </b-col>
            </b-row>

            <b-row>
              <b-col v-for="(commsPayoutSummary, index) in comms_payout_summaries" :key="commsPayoutSummary.comms_payout_summary_id">
                <div v-if="index == 0">Direct Payout</div>
                <div v-else>Advisory Direct Payout</div>
                <table class="table table-bordered" width="100%">
                    <thead>
                      <tr>
                          <th class="bg-dark text-white py-2">#</th>
                          <th class="bg-dark text-white py-2">User</th>
                          <th class="bg-dark text-white py-2">Payout Level</th>
                          <th class="bg-dark text-white py-2">Total Revenue Point</th>
                          <th class="bg-dark text-white py-2">Payout <br>Percentage <br>(%)</th>
                          <th class="bg-dark text-white py-2">Payout <br>Revenue Point</th>
                          <!-- <th class="bg-dark text-white py-1" width="200px">Manager Approval Status</th>
                          <th class="bg-dark text-white py-1" width="200px">Finance Approval Status</th>
                          <th class="bg-dark text-white py-1" width="200px">CEO Approval Status</th> -->
                        </tr>
                    </thead>
                    <tbody>
                      <template v-if="!show_actual_revenue">
                        <tr v-for="(direct_payout_detail, index) in commsPayoutSummary.direct_payout_details" :key="index">
                          <td class="py-2">{{ index+1 }}</td>
                          <td class="py-2">{{ direct_payout_detail.user.name }}</td>
                          <td class="py-2">{{ direct_payout_detail.payout_level_code }}</td>
                          <td class="py-2">RM {{ direct_payout_detail.total_revenue_point | moneyFormatter }}</td>
                          <td class="py-2">{{ direct_payout_detail.payout_percentage }}</td>
                          <td class="py-2">RM {{ direct_payout_detail.payout_revenue_point | moneyFormatter }}</td>
                          <!-- <template v-if="decide_mode">
                              <td class="py-1">
                                  <el-select
                                      v-model="direct_payout_detail.manager_approval_status" :disabled="permission.admin === false ? !permission.acceptor : !permission.admin"
                                  >
                                    <el-option
                                      v-for="item in options"
                                      :key="item.value"
                                      :label="item.label"
                                      :value="item.value"
                                    />
                                  </el-select>
                              </td>
                              <td class="py-1">
                                  <el-select
                                      v-model="direct_payout_detail.finance_approval_status" value-key="label" :disabled="permission.admin === false ? !permission.reviewer : !permission.admin"
                                  >
                                    <el-option
                                      v-for="item in options"
                                      :key="item.value"
                                      :label="item.label"
                                      :value="item.value"
                                    />
                                  </el-select>
                              </td>
                              <td class="py-1">
                                  <el-select
                                      v-model="direct_payout_detail.ceo_approval_status" :disabled="permission.admin === false ? !permission.approver : !permission.admin"
                                  >
                                    <el-option
                                      v-for="item in options"
                                      :key="item.value"
                                      :label="item.label"
                                      :value="item.value"
                                    />
                                  </el-select>
                              </td>
                          </template>
                          <template v-else>
                              <td class="py-1">{{ direct_payout_detail.manager_approval_status_name }}</td>
                              <td class="py-1">{{ direct_payout_detail.finance_approval_status_name }}</td>
                              <td class="py-1">{{ direct_payout_detail.ceo_approval_status_name }}</td>
                          </template> -->
                        </tr>
                      </template>
                      <template v-else>
                        <tr v-for="(direct_payout_detail, index) in commsPayoutSummary.direct_payout_details" :key="index">
                          <td class="py-2">{{ index+1 }}</td>
                          <td class="py-2">{{ direct_payout_detail.user.name }}</td>
                          <td class="py-2">{{ direct_payout_detail.payout_level_code }}</td>
                          <td class="py-2">RM {{ direct_payout_detail.actual_total_revenue_point | moneyFormatter }}</td>
                          <td class="py-2">{{ direct_payout_detail.payout_percentage }}</td>
                          <td class="py-2">RM {{ direct_payout_detail.actual_payout_revenue_point | moneyFormatter }}</td>
                        </tr>
                      </template>
                    </tbody>
                </table>
              </b-col>
            </b-row>

            <RecruitmentPayoutDetails
            :comms_payout_summaries="comms_payout_summaries"
            :decide_mode="decide_mode"
            :options="options"
            :show_actual_revenue="show_actual_revenue"
            :permission="permission" />

            <PoolContributionDetails 
            :comms_payout_summaries="comms_payout_summaries"
            :show_actual_revenue="show_actual_revenue"
            />
            
            <template v-if="decide_mode">
              <b-form-group
                label="Remark"
              >
                <b-form-textarea
                    id="remark"
                    v-model="remark"
                    placeholder="Enter some remark ..."
                    rows="4"
                    max-rows="4"
                >
                </b-form-textarea>
              </b-form-group>
            </template>

            <!-- <template>
              <b-row>
                <b-col cols="12" md="3">
                  <table class="table table-bordered" v-if="hub_pending_approval">
                    <thead>
                        <tr>
                          <th class="bg-primary text-white py-2" width="150px">Hub Manager Approval</th>
                          <td class="py-2">{{ hub_pending_approval.is_accepted_status_name }}</td>
                        </tr>
                        <tr>
                          <th class="bg-primary text-white py-2">Reviewer Approval</th>
                          <td class="py-2">{{ hub_pending_approval.is_reviewed_status_name }}</td>
                        </tr>
                        <tr>
                          <th class="bg-primary text-white py-2">CEO Approval</th>
                          <td class="py-2">{{ hub_pending_approval.is_approved_status_name }}</td>
                        </tr>
                    </thead>
                  </table>
                </b-col>
              </b-row>
                
            </template> -->
            <div class="text-red" v-if="permission.admin">**Note: You action of approval, will bypass all others approvers' approval process. <br>When you click on the below buttons, all the approvals will be fully done by you.</div>
        </b-col>
    </b-row>
    <template slot="footer" v-if="decide_mode && permission">
      <div class="d-flex justify-content-end w-100" v-if="permission.acceptor">
        <base-button type="danger" @click="acceptorAction(0)">Reject</base-button>
        <base-button type="success" @click="acceptorAction(1)">Approve</base-button>
      </div>
      <div class="d-flex justify-content-end w-100" v-if="permission.reviewer">
        <base-button type="danger" @click="reviewerAction(0)">Reject</base-button>
        <base-button type="success" @click="reviewerAction(1)">Approve</base-button>
      </div>
      <div class="d-flex justify-content-end w-100" v-if="permission.approver">
        <base-button type="danger" @click="approverAction(0)">Reject</base-button>
        <base-button type="success" @click="approverAction(1)">Approve</base-button>
      </div>
      <div class="d-flex justify-content-end w-100" v-if="permission.admin">
        <base-button type="danger" @click="adminAction(0)">Reject</base-button>
        <base-button type="success" @click="adminAction(1)">Approve</base-button>
      </div>
    </template>
</modal>
</template>
<style>
  .approval-direct-payout .el-select .el-input .el-input__inner{
    height: 25px;
  }
  .approval-direct-payout .el-select .el-input .el-select__caret{
    margin-top: 10px;
  }
  .approval-direct-payout .el-select .el-input.is-focus .el-input__inner{
    border: none;
  }
  .approval-direct-payout .el-select .el-input .el-input__inner:focus{
    border: none;
  }
</style>
<script>
import { Select, Option, Button } from 'element-ui'
import { notifyFunctionMixin,axios,services,getHeader,swal, helperFunctionMixin } from '@/assets/js/httpImports.js'
import RecruitmentPayoutDetails from './RecruitmentPayoutDetailsV2';
import PoolContributionDetails from './PoolContributionDetailsV2';
import { useAuthStore } from '@/stores/authStore'
import { mapState } from 'pinia'
import CurrencyInput from '@/components/CurrencyInput'

export default {
props: ['showDirectPayoutDetails', 'current_comms_payout_summaries','comms_payout_summaries','decide_mode', 'permission', 'hub_pending_approval'],
mixins: [notifyFunctionMixin, helperFunctionMixin],
components: {
      [Select.name]: Select,
      [Option.name]: Option,
      [Button.name]: Button,
      RecruitmentPayoutDetails,
      PoolContributionDetails,
      CurrencyInput,
    },
data() {
    return {
        openDirectPayoutDetailsModal: false,
        form: {},
        options: [
          {
            value: 1,
            label: 'Approve',
          },
          {
            value: 0,
            label: 'Reject',
          },
        ],
        remark: null,
        openActualRevenueAmountModal: false,
        actual_revenue_value: null,
        show_actual_revenue: false,
        case_recognize_id: null,
        new_comms_payout_summaries: [],
    }
},
computed:{
    ...mapState(useAuthStore, ['auth_user'])
},
created() {
},
methods:{
  updateDirectPayoutDetail(type, approval_status) {
    let comms_payout_summaries = this.comms_payout_summaries
  
    comms_payout_summaries.forEach((item) => {
      let formData = item.direct_payout_details;
      if(approval_status == 0)
      {
        switch(type)
        {
          case 'accept':
            formData.forEach((item) => {
              item.manager_approval_status = 0;
            }); 
          break;
          case 'review':
            formData.forEach((item) => {
              item.finance_approval_status = 0;
            }); 
          break;
          case 'approve':
            formData.forEach((item) => {
              item.ceo_approval_status = 0;
            }); 
          break;
          case 'admin':
            formData.forEach((item) => {
              item.manager_approval_status = 0;
              item.ceo_approval_status = 0;
              item.finance_approval_status = 0;
            }); 
          break;
        }
      }
      else
      { 
        switch(type)
        {
          case 'accept':
            formData.forEach((item) => {
              item.manager_approval_status = 1;
            }); 
          break;
          case 'review':
            formData.forEach((item) => {
              item.finance_approval_status = 1;
            }); 
          break;
          case 'approve':
            formData.forEach((item) => {
              item.ceo_approval_status = 1;
            }); 
          break;
          case 'admin':
            formData.forEach((item) => {
              item.manager_approval_status = 1;
              item.ceo_approval_status = 1;
              item.finance_approval_status = 1;
            }); 
          break;
        }
      }
      axios.post(services.hub + 'hub_comms/direct_payout_detail.custom_update', formData, {headers: getHeader()})
      .then(res  => {
        this.notifySuccess('<b>Direct Payout Details: </b> - Successfully Updated.', 2000)
      })
      .catch(e => {
        this.errorFunction(e)
      })
    });

  },
  updateRecruitmentPayoutDetail(type, approval_status) {
    let comms_payout_summaries = this.comms_payout_summaries

    comms_payout_summaries.forEach((item) => {
      let formData = item.recruitment_payout_details;
      if(approval_status == 0)
      {
        switch(type)
        {
          case 'accept':
            formData.forEach((item) => {
              item.manager_approval_status = 0;
            }); 
          break;
          case 'review':
            formData.forEach((item) => {
              item.finance_approval_status = 0;
            }); 
          break;
          case 'approve':
            formData.forEach((item) => {
              item.ceo_approval_status = 0;
            }); 
          break;
          case 'admin':
            formData.forEach((item) => {
              item.manager_approval_status = 0;
              item.ceo_approval_status = 0;
              item.finance_approval_status = 0;
            }); 
          break;
        }
      }
      else
      {
        switch(type)
        {
          case 'accept':
            formData.forEach((item) => {
              item.manager_approval_status = 1;
            }); 
          break;
          case 'review':
            formData.forEach((item) => {
              item.finance_approval_status = 1;
            }); 
          break;
          case 'approve':
            formData.forEach((item) => {
              item.ceo_approval_status = 1;
            }); 
          break;
          case 'admin':
            formData.forEach((item) => {
              item.manager_approval_status = 1;
              item.ceo_approval_status = 1;
              item.finance_approval_status = 1;
            }); 
          break;
        }
      }
      axios.post(services.hub + 'hub_comms/recruitment_payout_detail.custom_update', formData, {headers: getHeader()})
      .then(res  => {
        this.notifySuccess('<b>Recruitment Payout Details: </b> - Successfully Updated.', 2000)
      })
      .catch(e => {
        this.errorFunction(e)
      })
    });

  },
  executeApproval(status_name, status) {
    try {
      this.updateDirectPayoutDetail(status_name, status);
      this.updateRecruitmentPayoutDetail(status_name, status);
    } catch (error) {
      // Handle any errors that occur in the functions
      this.errorFunction(e)
    }
  },
  acceptorAction(is_accepted) {
    if(is_accepted == 0)
    {
      swal.fire({
      title: 'Are you sure?',
      text: "This will reject the approval!",
      icon: 'warning',
      // showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: 'Yes!',
      // denyButtonText: `Don't save`,
      }).then((result) => {
        if (result.isConfirmed) {
          this.executeApproval('accept', is_accepted);
          // this.updateDirectPayoutDetail('accept', is_accepted);
          // this.updateRecruitmentPayoutDetail('accept', is_accepted);
          this.submitReview(this.hub_pending_approval.next_approval_reviewers,is_accepted)
        }
      })
    }
    else
    {
      this.executeApproval('accept', is_accepted);
      // this.updateDirectPayoutDetail('accept', is_accepted);
      // this.updateRecruitmentPayoutDetail('accept', is_accepted);
      this.submitReview(this.hub_pending_approval.next_approval_reviewers,is_accepted)
    }
  },
  reviewerAction(is_reviewed) {
    if(is_reviewed == 0)
    {
      swal.fire({
      title: 'Are you sure?',
      text: "This will reject the approval!",
      icon: 'warning',
      // showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: 'Yes!',
      // denyButtonText: `Don't save`,
      }).then((result) => {
        if (result.isConfirmed) {
          this.executeApproval('review', is_reviewed);
          this.submitReview(this.hub_pending_approval.next_approval_reviewers,is_reviewed)
        }
      });
    }
    else
    {
      this.executeApproval('review', is_reviewed);
      this.submitReview(this.hub_pending_approval.next_approval_reviewers,is_reviewed)
    }
  },
  approverAction(is_approved) {

    const postData = {
      is_approved: is_approved,
      approver_remark: this.hub_pending_approval.approver_remark,
      approver_value: this.comms_payout_summaries,
    };
    swal.fire({
      title: 'Are you sure?',
      text: "This is the last approval stage, please read through carefully!",
      icon: 'warning',
      // showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: 'Yes!',
      // denyButtonText: `Don't save`,
    }).then((result) => {
      if (result.isConfirmed) {
        this.executeApproval('approve', is_approved);
        // await this.updateDirectPayoutDetail('approve', is_approved);
        // await this.updateRecruitmentPayoutDetail('approve', is_approved);
        this.submitReview(this.hub_pending_approval.next_approval_reviewers,is_approved,this.comms_payout_summaries)
      }
    })
  },
  adminAction(is_admin_approved) {
    const postData = {
      is_accepted: is_admin_approved,
      acceptor_remark: this.hub_pending_approval.acceptor_remark,
      is_reviewed: is_admin_approved,
      reviewer_remark: this.hub_pending_approval.reviewer_remark,
      is_approved: is_admin_approved,
      approver_remark: this.hub_pending_approval.approver_remark,
      approver_value: this.comms_payout_summaries,
    };

    swal.fire({
      title: 'Are you sure?',
      text: "This is the last approval stage, please read through carefully!",
      icon: 'warning',
      // showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: 'Yes!',
      // denyButtonText: `Don't save`,
    }).then((result) => {
      if (result.isConfirmed) {
        this.executeApproval('admin', is_admin_approved);
        // await this.updateDirectPayoutDetail('admin', is_admin_approved);
        // await this.updateRecruitmentPayoutDetail('admin', is_admin_approved);
        this.submitReview(this.hub_pending_approval.next_approval_reviewers,is_admin_approved, this.comms_payout_summaries)

      }
    })
  },
  submitReview(next_reviewers, val, appr_rev_value = null){
    const reviewer = next_reviewers.find((item) => item.appr_rev_user_id === this.auth_user.id)
    if(!reviewer){
        return
    }
    
    // this.is_loading_review = true
    let data = {
        'appr_rev_remark': this.remark,
        'appr_rev_value': appr_rev_value,
        'appr_rev_status': val
    }
    axios.put(services.approval + 'approval_reviewers/' + reviewer.appr_rev_id, data, {headers: getHeader()})
    .then(res => {
        this.remark = ''
        // this.is_loading_review = false
        this.notifySuccess('<b>Approval: - Successfully Reviewed.', 2000)
        this.$emit('refresh-approval')
        this.openDirectPayoutDetailsModal = false;
        this.show_actual_revenue = false;
    })
    .catch(e=>{
        // this.is_loading_review = false
        this.errorFunction(e)
    })
  },
  toggleActualRevenueAmountModal() {
    this.openActualRevenueAmountModal = !this.openActualRevenueAmountModal;
  },
  toggleShowActualRevenue() {
    this.show_actual_revenue = !this.show_actual_revenue;
    if(this.show_actual_revenue)
    {
      this.getCommsPayoutSummaries();
    }
  },
  submitActualRevenue() {
    const postData = {
      "cps_actual_develop_nett_price": this.actual_revenue_value
    }
    swal.fire({
      title: 'Are you sure?',
      text: 'Are you sure this is the actual revenue amount? RM ' + this.$options.filters.moneyFormatter(this.actual_revenue_value),
      icon: 'warning',
      // showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: 'Yes!',
      // denyButtonText: `Don't save`,
    }).then((result) => {
      if (result.isConfirmed) {
        // Assuming this.comms_payout_summaries is an array with data
        Promise.all(this.comms_payout_summaries.map(async (item) => {
            try {
                await axios.put(services.hub + 'hub_comms/comms_payout_summary/' + item.comms_payout_summary_id, postData, {headers: getHeader()});
            } catch (e) {
                this.errorFunction(e);
            }
        }))
        .then(() => {
            this.notifySuccess('<b>Actual Revenue: - Successfully Submitted.', 2000);
            this.notifyError('<b>Please remember to approve.', 2000);
            this.getCommsPayoutSummaries();
            this.openActualRevenueAmountModal = false;
            this.show_actual_revenue = true;
        })
        .catch(error => {
            // Handle any errors that occurred during the axios requests
            this.notifyError(error);
        });
      }
    })
  },
  getCommsPayoutSummaries() {
    axios.get(services.hub + 'hub_comms/comms_payout_summary.show_by_case_recognize_id/' + this.case_recognize_id, {headers: getHeader()})
    .then(res  => {
        this.new_comms_payout_summaries = res.data.data;
        this.$emit("update-comms-payout-summaries", this.new_comms_payout_summaries);
    })
    .catch(e => {
        this.errorFunction(e, 'error')
    })
  }
},
watch:{
    showDirectPayoutDetails(newVal){
      if(newVal){
          this.openDirectPayoutDetailsModal = true
      }
    },
    current_comms_payout_summaries() {
      this.case_recognize_id = this.current_comms_payout_summaries.case_recognize.case_recognize_id;
      this.actual_revenue_value = parseFloat(this.current_comms_payout_summaries.cps_develop_nett_price)
    },
    openDirectPayoutDetailsModal(newVal){
      if(!newVal){
          this.$emit("close-modal");
      }
    },
    decide_mode() {
      if(!this.decide_mode)
      {
        this.show_actual_revenue = false;
      }
    },
},
}  
</script>